var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8774,
    cy: 7.13522,
    r: 5.99038,
    stroke: "#88D57A",
    strokeWidth: 1.71154
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.75,
    cy: 13.125,
    r: 10.2692,
    fill: "#171717",
    stroke: "#88D57A",
    strokeWidth: 1.71154
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioIcon);
export default __webpack_public_path__ + "static/media/portfolio-icon.68d39cc0cab5a1ff09b88bc7a376246d.svg";
export { ForwardRef as ReactComponent };